import TextAndImageElement from './TextAndImageElement';
import ProjectQuote from './ProjectQuote';
import ProjectVideoModule from '../Project/ProjectVideoModule/ProjectVideoModule';
import ProjectImageModule from '../Project/ProjectImageModule/ProjectImageModule';
import {
  MultipleImageElementSchema,
  type PageElement,
  ProjectQuoteElementSchema,
  VideoElementSchema,
} from '../../schema/pageElements.val';
import DoubleMediaElement from './DoubleMediaElement';
import TextElement from './TextElement';
import LinksElement from './LinksElement';
import ListElement from './ListElement';
import LinkListsElement from './LinkListsElement';
import ImageCarousel from './ImageCarousel';
import DoubleProjectElement from '../ProjectElement/DoubleProjectElement';
import WideProjectElement from '../ProjectElement/WideProjectElement';
import TitleLinksElement from './TitleLinksElement';
import SingleMediaElement from './SingleMediaElement';
import { SocialCalendar } from '../SocialCalendar/SocialCalendar';

const ProjectQuoteC = (props: ProjectQuoteElementSchema) => (
  <div className="mx-auto">
    <ProjectQuote author={props.author ?? undefined}>
      {props.quote}
    </ProjectQuote>
  </div>
);

const ProjectVideoC = (props: VideoElementSchema) => (
  <div className="mx-[-24px] laptop:mx-0">
    <ProjectVideoModule videoFile={props.video} />
  </div>
);

const ProjectImageModuleC = (props: MultipleImageElementSchema) => (
  <div>
    <ProjectImageModule images={props.images} />
  </div>
);

const PageElement = ({ element }: { element: PageElement }) => {
  switch (element.type) {
    case 'textElement':
      return (
        <TextElement title={element.title ?? undefined} text={element.text} />
      );
    case 'doubleMediaElement':
      return (
        <DoubleMediaElement
          media={[element.media1, element.media2]}
          title={element.title ?? undefined}
          text={element.text ?? undefined}
          layout={element.layout}
        />
      );
    case 'singleMediaElement':
      return (
        <SingleMediaElement
          media={element.media}
          size="xl"
          keepAspectRatio={element.keepAspectRatio || false}
        />
      );
    case 'textAndImageElement':
      return (
        <TextAndImageElement
          image={element.image}
          title={element.title}
          text={element.text}
          side={element.side}
        />
      );
    case 'titleLinksElement':
      return <TitleLinksElement title={element.title} links={element.links} />;
    case 'linksElement':
      return <LinksElement links={element.links} />;
    case 'listElement':
      return <ListElement title={element.title} list={element.list} />;
    case 'projectQuoteElement':
      return <ProjectQuoteC {...element} />;
    case 'videoElement':
      return (
        <div className="w-full max-lg-content">
          <ProjectVideoC {...element} />
        </div>
      );
    case 'multipleImageElement':
      return (
        <div className="w-full max-w-full">
          <ProjectImageModuleC {...element} />
        </div>
      );
    case 'linkListsElement':
      return (
        <div className="w-full max-w-full">
          <LinkListsElement lists={element.lists} />
        </div>
      );
    case 'imageCarouselElement':
      return (
        <div className="w-full max-w-full">
          <ImageCarousel images={element.images} />
        </div>
      );
    case 'doubleProjectElement':
      return (
        <DoubleProjectElement
          leftProject={element.leftProject}
          rightProject={element.rightProject}
          alignSquareToTop={element.alignSquareToTop || false}
          reverseOrder={element.reverseOrder || false}
          type={element.type}
        />
      );
    case 'wideProjectElement':
      return (
        <WideProjectElement
          type={'wideProjectElement'}
          image={element.image}
          projectTitle={element.projectTitle}
          clientName={element.clientName}
          url={element.url}
          services={element.services || []}
        />
      );
    case 'socialCalendar':
      return <SocialCalendar />;
    default:
      return <div />;
  }
};

export default PageElement;
